import { render, staticRenderFns } from "./PowerupsCard.vue?vue&type=template&id=5b3d27cc&scoped=true&"
import script from "./PowerupsCard.vue?vue&type=script&lang=js&"
export * from "./PowerupsCard.vue?vue&type=script&lang=js&"
import style0 from "./PowerupsCard.vue?vue&type=style&index=0&id=5b3d27cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d27cc",
  null
  
)

export default component.exports